/* Demo HUD — a discreet background-activity log ─────────────────────────────
 * Press "o" to toggle a tiny bottom-left console (10 lines, 10px mono). It shows
 * what's happening in the background by mirroring client console.log/info/warn/
 * error AND every fetch() (method · path · status · ms). Self-contained: injects
 * its own CSS, installs its wrappers as early as it loads, never throws into the
 * host app. window.DemoLog.push(msg, level?) lets code add its own lines.
 *
 * Levels: info (default) · net (a fetch) · warn · error. Oldest line fades off
 * the top as new ones arrive.
 */
(function () {
  'use strict';
  if (window.DemoLog) return; // idempotent across SPA re-inits

  var MAX_VISIBLE = 10;   // lines shown before the oldest scrolls off
  var MAX_BUFFER = 400;   // history kept in memory
  var buffer = [];
  var root = null, list = null, visible = false;

  // ── styles (injected, so we don't depend on the cached stylesheet) ──────────
  function injectStyles() {
    if (document.getElementById('demo-log-styles')) return;
    var s = document.createElement('style');
    s.id = 'demo-log-styles';
    s.textContent = [
      '#demo-log{position:fixed;left:12px;bottom:12px;z-index:2147483000;',
      'width:min(440px,44vw);pointer-events:none;display:none;',
      "font:10px/15px ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;",
      'padding:9px 11px 8px;border-radius:9px;color:rgba(255,255,255,0.82);',
      'background:rgba(0,0,0,0.88);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);',
      'border:1px solid rgba(255,255,255,0.1);box-shadow:0 10px 34px rgba(0,0,0,0.5);}',
      '#demo-log.on{display:block;}',
      '#demo-log .dl-hd{display:flex;align-items:center;gap:6px;margin-bottom:6px;',
      'font-size:8px;letter-spacing:0.14em;text-transform:uppercase;color:rgba(255,255,255,0.34);}',
      '#demo-log .dl-copy{margin-left:auto;pointer-events:auto;cursor:pointer;border:none;background:transparent;',
      'color:rgba(255,255,255,0.4);font-size:11px;line-height:1;padding:2px 4px;border-radius:4px;',
      'display:inline-flex;align-items:center;transition:color .12s ease,background .12s ease;}',
      '#demo-log .dl-copy:hover{color:rgba(255,255,255,0.9);background:rgba(255,255,255,0.08);}',
      '#demo-log .dl-copy.ok{color:#5ec26a;}',
      '#demo-log .dl-dot{width:5px;height:5px;border-radius:50%;background:#5ec26a;',
      'box-shadow:0 0 6px rgba(94,194,106,0.8);animation:dlPulse 1.6s ease-in-out infinite;}',
      '@keyframes dlPulse{0%,100%{opacity:0.35}50%{opacity:1}}',
      '#demo-log .dl-list{display:flex;flex-direction:column;',
      '-webkit-mask-image:linear-gradient(to bottom,transparent 0,#000 20px);',
      'mask-image:linear-gradient(to bottom,transparent 0,#000 20px);}',
      '#demo-log .dl-row{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '#demo-log .dl-t{color:rgba(255,255,255,0.3);}',
      '#demo-log .dl-net{color:rgba(255,255,255,0.56);}',
      '#demo-log .dl-srv{color:rgba(150,184,255,0.72);}', // server-side lines, softly tinted',
      '#demo-log .dl-warn{color:#d9a441;}',
      '#demo-log .dl-error{color:#e06c6c;}',
      '@media (prefers-reduced-motion:reduce){#demo-log .dl-dot{animation:none;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function ensureDom() {
    if (root) return;
    injectStyles();
    root = document.createElement('div');
    root.id = 'demo-log';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = '<div class="dl-hd"><span class="dl-dot"></span>background' +
      '<button class="dl-copy" type="button" title="Copy log to clipboard" aria-label="Copy log">⧉</button></div>' +
      '<div class="dl-list"></div>';
    (document.body || document.documentElement).appendChild(root);
    list = root.querySelector('.dl-list');
    var copyBtn = root.querySelector('.dl-copy');
    if (copyBtn) copyBtn.addEventListener('click', copyLog);
    render();
  }

  // Copy the whole in-memory buffer (timestamp + message per line) to the clipboard.
  function copyLog(e) {
    if (e) e.stopPropagation();
    var text = buffer.map(function (r) { return r.t + '  ' + r.msg; }).join('\n');
    var done = function () {
      var b = root && root.querySelector('.dl-copy');
      if (!b) return; b.textContent = '✓'; b.classList.add('ok');
      setTimeout(function () { b.textContent = '⧉'; b.classList.remove('ok'); }, 1200);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { fallbackCopy(text); done(); });
    } else { fallbackCopy(text); done(); }
  }
  function fallbackCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (_) {}
      document.body.removeChild(ta);
    } catch (_) {}
  }

  function two(n) { return (n < 10 ? '0' : '') + n; }
  function stamp() { var d = new Date(); return two(d.getHours()) + ':' + two(d.getMinutes()) + ':' + two(d.getSeconds()); }

  function esc(s) {
    return String(s).replace(/[&<>]/g, function (c) { return c === '&' ? '&amp;' : c === '<' ? '&lt;' : '&gt;'; });
  }

  function render() {
    if (!list) return;
    var rows = buffer.slice(-MAX_VISIBLE);
    var html = '';
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      html += '<div class="dl-row ' + (r.level ? 'dl-' + r.level : '') + '">' +
        '<span class="dl-t">' + r.t + '</span> ' + esc(r.msg) + '</div>';
    }
    list.innerHTML = html;
  }

  function push(msg, level) {
    if (msg == null || msg === '') return;
    buffer.push({ t: stamp(), msg: String(msg).slice(0, 220), level: level || '' });
    if (buffer.length > MAX_BUFFER) buffer.splice(0, buffer.length - MAX_BUFFER);
    if (visible) render();
  }

  function toggle() {
    ensureDom();
    visible = !visible;
    root.classList.toggle('on', visible);
    if (visible) render();
  }

  // ── capture: console ────────────────────────────────────────────────────────
  function fmtArgs(args) {
    var out = [];
    for (var i = 0; i < args.length; i++) {
      var a = args[i];
      if (a == null) { out.push(String(a)); continue; }
      if (typeof a === 'string' || typeof a === 'number' || typeof a === 'boolean') { out.push(a); continue; }
      if (a instanceof Error) { out.push(a.message); continue; }
      try { out.push(JSON.stringify(a)); } catch (_) { out.push(Object.prototype.toString.call(a)); }
    }
    return out.join(' ');
  }
  var wrappersInstalled = false;
  function installWrappers() {
    if (wrappersInstalled) return;
    wrappersInstalled = true;
    ['log', 'info', 'warn', 'error'].forEach(function (m) {
      var orig = console[m] ? console[m].bind(console) : function () {};
      console[m] = function () {
        try { push(fmtArgs(arguments), m === 'warn' ? 'warn' : m === 'error' ? 'error' : ''); } catch (_) {}
        return orig.apply(null, arguments);
      };
    });

  // ── capture: fetch (method · path · status · ms) ────────────────────────────
  function shortPath(url) {
    try { var u = new URL(url, window.location.origin); var p = u.pathname; if (u.search) p += (u.search.length > 24 ? u.search.slice(0, 24) + '…' : u.search); return p; }
    catch (_) { return String(url).slice(0, 60); }
  }
  if (window.fetch && !window.fetch.__demoWrapped) {
    var of = window.fetch;
    var wrapped = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var path = shortPath(url);
      var start = Date.now();
      return of.apply(this, arguments).then(function (res) {
        push(method + ' ' + path + ' · ' + res.status + ' · ' + (Date.now() - start) + 'ms', res.ok ? 'net' : 'error');
        return res;
      }, function (err) {
        push(method + ' ' + path + ' · failed', 'error');
        throw err;
      });
    };
    wrapped.__demoWrapped = true;
    window.fetch = wrapped;
  }
  }

  // Wrappers only install on devices that USE the HUD (first ⌥O arms it persistently, so later
  // page loads capture from the start, exactly as before). Everyone else skips paying the
  // console/fetch wrapper + formatting + buffer cost on every call, forever.
  var armed = false;
  try { armed = localStorage.getItem('demoLogArmed') === '1'; } catch (_) {}
  if (armed) installWrappers();

  // ── server-log stream (SSE) ─────────────────────────────────────────────────
  // Opened lazily the first time the HUD is shown, so it never connects for users who
  // don't use it. Gated + auth'd server-side (see routes/devLog.js). Server lines get a
  // soft tint so they read distinctly from client ones; warn/error keep their colour.
  var es = null;
  function connectServer() {
    if (es || typeof EventSource === 'undefined') return;
    try { es = new EventSource('/_devlog/stream'); } catch (_) { return; }
    es.onmessage = function (ev) {
      try {
        var e = JSON.parse(ev.data);
        push(e.msg, e.level === 'warn' ? 'warn' : e.level === 'error' ? 'error' : 'srv');
      } catch (_) {}
    };
    es.onerror = function () {
      // Disabled (prod), unauthorised, or dropped — stop retrying; reconnect on next open.
      try { es.close(); } catch (_) {}
      es = null;
    };
  }

  // ── toggle key (Option/Alt + O — plain "o" is the search shortcut) ──────────
  document.addEventListener('keydown', function (e) {
    if (e.code !== 'KeyO') return;                    // layout-safe: Alt+O emits "ø" on macOS
    if (!e.altKey || e.metaKey || e.ctrlKey) return;
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    e.preventDefault();
    if (!wrappersInstalled) {
      installWrappers();
      try { localStorage.setItem('demoLogArmed', '1'); } catch (_) {}
      push('capture armed - reload to log from page start', '');
    }
    toggle();
    if (visible) connectServer();
  });

  window.DemoLog = { push: push, toggle: toggle };
  push('demo log ready - ⌥O to toggle', '');
})();
